export interface WorkshopImage {
  src: string;
  alt: string;
  caption: string;
}

export const workshopGalleryImages: WorkshopImage[] = [
  {
    src: "/lovable-uploads/0749ac56-c59c-4484-86c1-bac8b3692007.png",
    alt: "Clean room mixing system installation",
    caption: "Professional installation of mixing systems in controlled clean room environment with hygienic design standards"
  },
  {
    src: "/lovable-uploads/0ad40805-65dc-4f47-abb4-168c03512b04.png",
    alt: "Large tank transportation setup",
    caption: "Secure transportation preparation for large industrial tanks with specialized rigging and tie-down systems"
  },
  {
    src: "/lovable-uploads/17466fd6-2042-4760-a5cb-fbb731463cdc.png",
    alt: "Mobile mixing vessels on casters",
    caption: "Mobile stainless steel mixing vessels equipped with heavy-duty casters for flexible positioning in production environments"
  },
  {
    src: "/lovable-uploads/1d87ab22-526b-42ac-857c-cfcfe0f564b4.png",
    alt: "Large diameter shell rolling process",
    caption: "Precision shell rolling operation for large diameter vessels showcasing our advanced forming capabilities"
  },
  {
    src: "/lovable-uploads/23086d16-ca86-40a7-bc92-4a1d9a30117d.png",
    alt: "Heavy lifting tank fabrication",
    caption: "Industrial crane operations during the fabrication process of large-scale storage tanks in our workshop facility"
  },
  {
    src: "/lovable-uploads/29125048-112b-466c-ab43-783d1654f4e4.png",
    alt: "Precision welding in progress",
    caption: "Expert TIG welding operations on stainless steel tank components with certified welders ensuring highest quality standards"
  },
  {
    src: "/lovable-uploads/3d01fb44-e4a1-42a7-9920-fb4f315e157b.png",
    alt: "Workshop quality control inspection",
    caption: "Thorough quality control and inspection process ensuring all fabricated components meet strict industry standards"
  },
  {
    src: "/lovable-uploads/3d099546-68da-4ebe-a6ea-47fdf378b4e7.png",
    alt: "Stainless steel surface finishing",
    caption: "Professional surface finishing operations achieving mirror polish and electropolished surfaces for pharmaceutical applications"
  },
  {
    src: "/lovable-uploads/5138a6e4-8dd2-4d1f-be3d-81a463bf2d08.png",
    alt: "Multi-tank assembly operation",
    caption: "Assembly of multiple tank systems with integrated piping and instrumentation in our state-of-the-art workshop"
  },
  {
    src: "/lovable-uploads/61292f7b-9922-44fd-8d23-b15d5a2e7225.png",
    alt: "Custom component fabrication",
    caption: "Precision fabrication of custom tank components and fittings using advanced machining and forming techniques"
  }
];